// extracted by mini-css-extract-plugin
export var author = "menuCustomers-module--author--513f7";
export var category = "menuCustomers-module--category--9e7f6";
export var customersSection = "menuCustomers-module--customersSection--cca79";
export var headline = "menuCustomers-module--headline--1da52";
export var headlinePost = "menuCustomers-module--headline-post--82beb";
export var industriesGrid = "menuCustomers-module--industriesGrid--4f683";
export var industriesSection = "menuCustomers-module--industriesSection--cf073";
export var industriesTitle = "menuCustomers-module--industriesTitle--96c74";
export var itemsCol = "menuCustomers-module--itemsCol--2a7de";
export var itemsWrapper = "menuCustomers-module--itemsWrapper--f6e74";
export var paragraph = "menuCustomers-module--paragraph--81019";